module.exports = __webpack_public_path__ + "Banner_PORTFOLIO_MANAGEMENT.jpg?52648e01e3fd92c56083044605baf0eb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/Banner_PORTFOLIO_MANAGEMENT.jpg
// module id = 214
// module chunks = 0